const occupationContent = {
    "name_value_pair": [
        {
            "key_name": "Salaried Person",
            "key_value": "S"
        },
        {
            "key_name": "Self Employed Person",
            "key_value": "E"
        },
        {
            "key_name": "Retired Person",
            "key_value": "P"
        }
    ]
}

export default occupationContent;